import React, { useState } from "react";
import { Plus, Minus } from "lucide-react";
import teamdis from "../img/teamdis.jpg";

const FAQSection = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "What services does SecurXpert provide?",
      answer:
        "We provide IT Solutions, Web & Software Development Services, Business Process Services, Staffing, AI & Data Analytics Solutions, Training & Placement.",
    },
    {
      question: "Do you offer custom software development?",
      answer:
        "Yes, we specialize in building scalable and tailored software solutions as per your business requirements.",
    },
    {
      question: "How do I get in touch for a quote or project inquiry?",
      answer:
        "You can fill out our contact form at the bottom of the page or call us at the number listed. We typically respond within 24 hours.",
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <section className="relative bg-gray-50 overflow-hidden py-5 sm:py-16 px-4 sm:px-6 lg:px-12">
      {/* subtle background pattern */}
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/circuit-board.png')] opacity-10"></div>

      <div className="relative max-w-7xl mx-auto">
        {/* Mobile: Stack vertically, full width */}
        <div className="lg:grid lg:grid-cols-2 lg:gap-20 lg:items-center">
          
          {/* LEFT CONTENT */}
          <div className="lg:order-1 order-2 mb-8 lg:mb-0">
            <p className="text-blue-600 uppercase tracking-wide font-semibold text-xs sm:text-sm mb-3 sm:mb-2">
              Frequently Ask Question
            </p>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-extrabold text-gray-900 mb-6 sm:mb-8 leading-tight sm:leading-snug">
              Get Quick Answers To <br className="hidden sm:block" />
              Common Queries About <br className="block sm:hidden" />
              Our Services.
            </h2>

            <div className="space-y-3 sm:space-y-4">
              {faqs.map((faq, index) => (
                <div
                  key={index}
                  className="bg-white shadow-sm hover:shadow-md transition-all rounded-xl border border-gray-100"
                >
                  <button
                    className="w-full flex justify-between items-center px-4 sm:px-6 py-4 sm:py-5 text-left font-semibold text-gray-900 text-base sm:text-lg"
                    onClick={() => toggleFAQ(index)}
                  >
                    {faq.question}
                    {activeIndex === index ? (
                      <Minus className="text-blue-600 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
                    ) : (
                      <Plus className="text-blue-600 w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0" />
                    )}
                  </button>

                  <div
                    className={`overflow-hidden transition-all duration-500 ${
                      activeIndex === index ? "max-h-48 sm:max-h-40 pb-4 sm:pb-4" : "max-h-0"
                    }`}
                  >
                    <p className="px-4 sm:px-6 text-gray-700 leading-relaxed text-sm sm:text-base">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT IMAGE - size in rem, bigger on lg but safe */}
          <div className="flex justify-center lg:justify-end lg:order-2 lg:mt-[8rem]">
            <img
              src={teamdis}
              alt="Team discussion"
              className="
                rounded-2xl shadow-xl
                w-full max-w-[18rem] sm:max-w-[22rem] md:max-w-[26rem] lg:max-w-[36rem] 
                h-auto object-cover
                mx-auto lg:mx-0
              "
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;